export default __webpack_public_path__ + "static/media/설치.cd7260a7.png";